<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header bg-primary text-white">公告</div>
              <ul class="list-group list-group-flush">
                <li
                  v-for="announcement in announcements"
                  :key="announcement.id"
                  class="list-group-item"
                  @click="showAnnouncement(announcement)"
                >
                  <div class="icon-container">
                    <i
                      v-if="announcement.type == 'warning'"
                      class="fas fa-exclamation-triangle icon icon-warning"
                    ></i>
                    <i
                      v-if="announcement.type == 'danger'"
                      class="fas fa-exclamation-circle icon icon-danger"
                    ></i>
                    <i
                      v-if="announcement.type == 'normal'"
                      class="fas fa-info-circle icon icon-normal"
                    ></i>
                  </div>
                  <div class="text-content">
                    <h5>{{ announcement.title }}</h5>
                    <p>{{ announcement.createdAt | moment("YYYY/MM/DD") }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import db from "../../api/db";

export default {
  name: "AnnouncementListScreen",
  components: {
    MemberLayout
  },
  data() {
    return {
      announcements: []
    };
  },
  methods: {
    showAnnouncement(announcement) {
      this.$swal({
        title: announcement.title,
        text: announcement.content
      });
    }
  },
  mounted() {
    const vm = this;
    db.collection("announcements")
      .where("isPublished", "==", true)
      .orderBy("createdAt", "desc")
      .get()
      .then(docs => {
        const announcements = [];
        docs.forEach(doc => {
          const announcement = doc.data();
          announcement.id = doc.id;
          announcements.push(announcement);
        });
        vm.announcements = announcements;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style scoped>
.list-group-item {
  display: flex;
}
.icon-container {
  width: 80px;
  height: 80px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-content {
  flex: 1;
}
.icon {
  font-size: 50px;
}
.icon-warning {
  color: #f48924;
}
.icon-danger {
  color: #ff3939;
}
.icon-normal {
  color: #dddddd;
}
</style>